import { intl } from '@/intl'

/**
 * Validates the given location object.
 *
 * @param location The location object to validate.
 * @returns A string error message if validation fails, otherwise undefined.
 */
export function validateLocation(location: uui.domain.client.Location): string | undefined {
  switch (location.status) {
    case 'GEOCODING_ERROR':
    case 'GEOCODING_FAILED':
    case 'NOT_FOUND':
      return intl.translate({ id: 'locationEditorField.error.invalid' })
    case 'GEOCODING_TIMEOUT':
      return intl.translate({ id: 'locationEditorField.error.timeout' })
    case 'OUT_OF_TERRITORY_RANGE':
      return intl.translate({ id: 'locationEditorField.error.outOfTerritory' })
    default:
      return
  }
}
